export { default } from './AlarmBellSnooze'
